import { IconFileText } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineLinkCell } from "../../../../../mantine/mrt/components/cell/MantineLinkCell";
import urls from "../../../../../urls";
import type { Paragraph6FinancialDocument } from "../../../Paragraph6.types";
import { FinancialDocumentType } from "../../../Paragraph6.types";

function getDocumentColumn() {
  return {
    header: "Dokument",
    accessorKey: "document_name",
    id: "document",
    enableColumnFilter: false,
    enableCellHoverReveal: true,
    Cell: ({ renderedCellValue, row }) => (
      <DocumentDownloadCell
        id={row.original.id}
        renderedCellValue={renderedCellValue}
        type={row.original.type}
      />
    )
  } satisfies MRT_ColumnDef<Paragraph6FinancialDocument>;
}

interface DocumentDownloadCellProps {
  id: string;
  renderedCellValue: React.ReactNode;
  type?: FinancialDocumentType;
}

function DocumentDownloadCell({
  id,
  renderedCellValue,
  type
}: DocumentDownloadCellProps) {
  let downloadUrl: string;

  switch (type) {
    case FinancialDocumentType.Credit:
    case FinancialDocumentType.PaymentInformation:
      downloadUrl = urls.apiWithoutCamelization.paragraph6CreditDocument(id);
      break;

    case FinancialDocumentType.Cancellation:
      downloadUrl =
        urls.apiWithoutCamelization.paragraph6CancellationDocument(id);
      break;

    default:
      throw "invalid document type";
  }

  return (
    <MantineLinkCell
      download
      IconComponent={IconFileText}
      renderedCellValue={renderedCellValue}
      url={downloadUrl}
    />
  );
}
export { getDocumentColumn };
